module.exports = __webpack_public_path__ + "media/bootstrap-icons/person-dash-fill-22314d8f.svg";